import WSConnectManager from "@/pages/WebSocketConnect.vue";

import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
//import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";

// Dashboard pages
import Dashboard from "@/pages/Dashboard/Dashboard.vue";
import GlobalDashboard from "../pages/Dashboard/GlobalDashboard.vue";

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/pages/Dashboard/Pages/Login.vue"),
  },
  {
    path: "/",
    component: WSConnectManager,
    children: [
      {
        path: "",
        redirect: "/global",
      },
      {
        path: "",
        component: DashboardLayout,
        children: [
          {
            path: "classrooms/:classroomPath",
            name: "Classroom Dashboard",
            components: { default: Dashboard },
            meta: { requiresAuth: true },
          },
          {
            path: "/global",
            name: "All Classrooms Dashboard",
            components: { default: GlobalDashboard },
            meta: { requiresAuth: true },
          },
        ],
      },
    ],
  },
];

export default routes;
